/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.buttongroup[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%], .smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-bottom:10px}.padding[_ngcontent-%COMP%]{padding:20px}.actionbar[_ngcontent-%COMP%], .margintop[_ngcontent-%COMP%]{margin-top:15px}.wideselect[_ngcontent-%COMP%]{width:300px}.thinform[_ngcontent-%COMP%]     .mat-form-field-infix{border-top:none}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/adoptionrequest/adoptionrequest.component.css.shim.ngstyle.js.pre-build-optimizer.js